import React, { Component } from 'react';
import './newHeader.scss'
import { Tooltip, Modal, Button } from 'antd';
import {store} from 'Store/store.index';
import { inject, observer } from 'mobx-react';
// import { createFolder } from "../../api/newOnline/doc";
// import { HOME_HEADER } from '@/constants/index'
import { cmisInfo } from "../../api/fwApi/webpdfapi";
@inject('userNewStore', 'common')
@observer
class meeting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docId: "", // ! 上传文档的Id
      isShowDialog: false
    };
  }

  // ! 云会议入口
  goToMeeting = () => {
    //!如果用户未登录或用户未打开文档，则直接跳转到云会议页面
    
    if(!store.loginNewStore.isLogin || !store.viewer.hasOpenFile) {
      window.open("https://huiyi.foxitcloud.cn/web/")
      return
    }
    // 文档已经修改 store.appStore.docModified
    if (store.appStore.docModified && !store.saveFileNewStore.isSaveSuccess) {
      this.setState({
        isShowDialog: true
      })
      return
    }
    console.log(1111)
    store.common.setIsShowMeeting(true) 
    console.log(2222)
    store.docsStore.getToken().then(res => {
      console.log(33333)
      // !获取token = res.data.token
      if(res.code === 0) {
        store.docsStore.getRootFolder().then(resFolder => {
          // !获取根目录id: folderId = res.data.folderId
          if(resFolder.code === 0){
            if(store.saveFileNewStore.isSaveSuccess) {
              store.appStore.doUpdateDocModified(false, true)
              store.saveFileNewStore.setIsSaveSuccess(false)
            }
            let docsFolderId = resFolder.data.folderId
            this.createFolder(docsFolderId, "云会议");
          }
        }).catch(() => {
          store.common.setIsShowMeeting(false) 
        })
      }
    }).catch(() => {
      store.common.setIsShowMeeting(false) 
    })
  }
  saveFiles = () => {
    store.common.setIsShowMeeting(true) 
    this.setState({
      isShowDialog: false
    })
    store.saveFileNewStore.saveFile("downFile")
  }
  /**
   * [createFolder 创建文件夹]
   *
   * @return  {[type]}  [return description]
   */
  async createFolder(parentId, name) {
    // 查询是否有云会议的文件夹，没有则新建，有则使用云会议的文件夹
    const pdfDoc = await window.pdfui.getCurrentPDFDoc();
    let fileName = pdfDoc.info.fileName
    store.docsStore.getFindDocFolder(parentId).then(res => {
      if (res.code === 0) {
        let haveFolder = false
        let folderId = ""
        const nowDate = new Date();
        const year = nowDate.getFullYear();
        const mouth = nowDate.getMonth()+1;
        const day =  nowDate.getDate()
        
        let dataName = `${year}${mouth>9?'':'0'}${mouth}${day>9?'':'0'}${day}`
        // 20211130修改逻辑，当有云会议文件夹时添加日期文件夹
        res.data && res.data.forEach(item => {
          if(item.folderName === "云会议") {
            haveFolder = true
            folderId = item.folderId
          }
        })
        if(haveFolder) { //! 有云会议文件夹
          //! 上传打开文档，parentId为主文件夹id,这里在云会议文件夹folderId下查询是否有日期文件夹，无：添加日期文件夹；有保存
          store.docsStore.getFindDocFolder(folderId).then(res2 => {
            let haveDateFolder = false
            res2.data && res2.data.forEach(item => {
              if(item.folderName == dataName) {
                haveDateFolder = true
                folderId = item.folderId
              }
            })
            if (haveDateFolder) { // 有日期文件
              this.fileToBlobAndUpload(fileName, folderId);
            } else { // 无日期文件
              store.docsStore.addDocFolder(folderId, dataName).then(resAdd => {
                if(resAdd.code === 0) {
                  this.fileToBlobAndUpload(fileName, resAdd.data.folderId);
                }
              }).catch(() => {
                store.common.setIsShowMeeting(false) 
                this.setState({
                  showLoadingMeeting: false
                })
              })
            }
          })
        } else { //! 没有云会议文件夹：创建
          store.docsStore.addDocFolder(parentId, name).then(resNoMeeting => {
            if(resNoMeeting.code === 0) {
              // 创建云文件夹后创建今天的日期文件夹
              store.docsStore.addDocFolder(resNoMeeting.data.folderId, dataName).then(resAdd2 => {
                if(resAdd2.code === 0) {
                  this.fileToBlobAndUpload(fileName, resAdd2.data.folderId);
                }
              }).catch(() => {
                store.common.setIsShowMeeting(false) 
              })
            }
          }).catch(() => {
            store.common.setIsShowMeeting(false) 
          })
        }
      }
    }).catch(() => {
      store.common.setIsShowMeeting(false) 
    })
  }
  // 获取文档流并上传
  fileToBlobAndUpload(fileName='', folderId) {
    // !云会议文件不占用云文档空间，添加参数 isfree = true
    store.docsStore.fileToBlob(fileName, folderId, true).then(res => {
      if (res.code === 0) {
        // !保存文件id
        this.setState({
          docId: res.data.docId
        })
        //! 触发打开云会议的操作
        this.meetingBegin(fileName)
      } else if (res.code === 40002) {
        //40002 文件名重名 添加时间戳
        let time = store.docsStore.formatCompleteTime(new Date());
        let fileNamePrefix = fileName.substring(
          0,
          fileName.lastIndexOf(".")
        );
        fileName = `${fileNamePrefix}_${time}.pdf`
        store.docsStore.fileToBlob(fileName, folderId)
        // this.uploadDocument(blob, loadingText);
      } else if (res.code === 30004) {
        store.common.setIsShowMeeting(false) 
        Modal.info({
          title: '福昕云编辑',
          content: (
            <div>
              <p>保存失败，当前目录不存在</p>
            </div>
          ),
          onOk() {},
        });
      } else if (res.code === 40003) {
        //1004 空间不足
        store.common.setIsShowMeeting(false) 
        store.docsStore.lackOfSpace();
      } else {
        store.common.setIsShowMeeting(false) 
      }
    }).catch(() => {
      store.common.setIsShowMeeting(false) 
    })
  }
  meetingBegin(fileName) {
    const fileObjectId = this.state.docId; // ! 文档的Id
    const token = store.docsStore.docsToken
    const params = {
      nickName: store.userNewStore.userData.nickname,
      userImage: store.userNewStore.userData.figure,
      userId: store.userNewStore.userData.userId,
      cmisToken: token,
      fileUrl: `https://docsapi.foxitcloud.cn/docFile/downloadFile?${store.loginNewStore.IAMToken? 'accessToken' : 'token'}=${token}&docId=${fileObjectId}&appKey=${store.docsStore.appKey}`,
      fileObjectId,
      fileName
    };
    const config = {
      headers: {
        "Content-Type": "application/json"
      },
      loadingText: "会议室筹备中"
    };
    cmisInfo(params, config).then(res => {
      // window.location.href = `https://huiyi.foxitcloud.cn/web?cmiscode=${res.data}`;
      store.common.setIsShowMeeting(false) // 显示loading
      window.open(`https://huiyi.foxitcloud.cn/web?cmiscode=${res.data}`);
    }).catch(() => {
      store.common.setIsShowMeeting(false) // 显示loading
    });
  }
  // ! 时间格式化
  formatTime(date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return [year, month, day].map(this.formatNumber).join("");
  }
  // !时间转换
  formatNumber(n) {
    let i = n.toString();
    return i[1] ? i : "0" + i;
  }


  render() {
    const {isShowDialog} = this.state
    return (
      <div className='meeting-btn-box'>
        <Tooltip  placement="bottom" title={"云会议"}>
          <i className="icon-btn cursor-pointer meeting-btn" onClick={this.goToMeeting}></i>
        </Tooltip>
        {
          isShowDialog && <Modal
            width={450}
            closable = { true }
            title="福昕云编辑"
            visible = { isShowDialog }
            className = "noPdf"
            footer = {[
              <Button key="submit" type="primary" onClick={this.saveFiles}>保存</Button>,
              <Button key="cancel" onClick={() => {this.setState({isShowDialog:false})}}>取消</Button>
            ]}
            onCancel= {() => {this.setState({isShowDialog:false})}}
          >
            <img  src={require('../../assets/fw_cloud_editor/main/warning.png')} alt="提示" /> <br/>
            <p>
              您的文件已经被修改，是否要保存？
            </p>
          </Modal>
        }
      </div>
    )
  }
}
export default meeting;
